import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/shared/components/ui/dialog'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'

interface DeleteQuoteDialogProps {
  open: boolean
  quoteName: string
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isLoading?: boolean
}

export const DeleteQuoteDialog = ({
  open,
  quoteName,
  onOpenChange,
  onConfirm,
  isLoading,
}: DeleteQuoteDialogProps) => {
  const { t } = useLocalization()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('Delete quote', 'Ta bort order')}</DialogTitle>

          <DialogDescription className="mt-2">
            {t(
              'Are you sure you want to delete',
              'Är du säker på att du vill ta bort'
            )}{' '}
            "{quoteName}"?{' '}
            {t(
              'This action cannot be undone.',
              'Denna åtgärd kan inte ångras.'
            )}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>
            {t('Cancel', 'Avbryt')}
          </Button>

          <Button
            variant="destructive"
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {t('Delete', 'Ta bort')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
